export default __webpack_public_path__ + "static/media/Bright Bonus Win.4fda3cd3.wav";